import { render, staticRenderFns } from "./DocumentaryRequirements.vue?vue&type=template&id=68043931"
import script from "./DocumentaryRequirements.vue?vue&type=script&lang=js"
export * from "./DocumentaryRequirements.vue?vue&type=script&lang=js"
import style0 from "./DocumentaryRequirements.vue?vue&type=style&index=0&id=68043931&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports